export const WORKFLOW_ACTIONS = {
    MARKETO_ADD_CONTACT_TO_CAMPAIGN: 'DSKMNXSSHJEG7HEZGA8RFL',
};

export const WORKFLOW_ACTION_PROPERTIES = {
    [WORKFLOW_ACTIONS.MARKETO_ADD_CONTACT_TO_CAMPAIGN]: {
        CAMPAIGN_ID: 'campaign_id',
    },
};

export const WORKFLOW_MAX_LIMIT_REACHED_ERROR = 'MAX_ON_WORKFLOWS_LIMIT_REACHED';
export const WORKFLOW_DEFAULT_MAX_LIMIT = 25;

export const WORKFLOW_ACCOUNT_ACTION_CONTACT_FILTER_BASE = {
    rule_type: 'attribute',
    source: 'rollworks',
    object: 'contact_data',
    type: 'string',
};

export const WORKFLOW_CLONE_TEMP_EID = 'workflow_clone_temporary_eid';

export const WORKFLOW_SCHEDULE_DEFAULT = '0 */6 * * *';
export const WORKFLOW_SCHEDULE_DAYS_OF_WEEK: { [day: string]: string } = {
    SUN: '0 13 * * SUN',
    MON: '0 13 * * MON',
    TUE: '0 13 * * TUE',
    WED: '0 13 * * WED',
    THU: '0 13 * * THU',
    FRI: '0 13 * * FRI',
    SAT: '0 13 * * SAT',
};


export const WORKFLOW_TEMPLATE_EIDS = {
    ACQUIRE_NEW_CONTACTS: 'MMQYFH57UFG7HCEWTY8RFL',
    ACQUIRE_HOT_CONTACTS: '2YMACWWY2VH5ROO3NX8RFL', // Also known as 'Discover New Contacts'
};

export const WORKFLOW_DEFAULT_NAMES = {
    [WORKFLOW_TEMPLATE_EIDS.ACQUIRE_NEW_CONTACTS]: 'Acquire Contacts',
    [WORKFLOW_TEMPLATE_EIDS.ACQUIRE_HOT_CONTACTS]: 'Acquire New Hot Contacts',
};
